module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Login.json
// module id = 591
// module chunks = 1